// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:focus-visible {
  outline: none;
}

:root {
  --article: #313237;
  --background: #f6f8fa;
  --background-box: #fffffff0;
  --background-header: #f5f4f4b8;
  --background-label: rgb(236, 236, 236);
  --background-info: #f1f1f1;
  --background-input: #eff1f3;
  --background-popup: #0000009f;
  --background-popup-box: #eaeaea;
  --border: #d7d7d7;
  --border-default: 1px solid var(--border);
  --button: #5297f1;
  --button-text: white;
  --button-border: #2ea15e;
  --button-hover: #69b65c;
  --button-disabled: #b8b8b8;
  --grid: #f8f9fb;
  --height-header: 35px;
  --link: #5297f1;
  --link-selected: #d0dcff;
  --text: #5f6368;
  --text-disabled: #999ea4;
  --text-red: #ff4545;
  --text-important: #101010;
  --box-shadow-default: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  --formatter-selected: #aae9ba;
  --placeholder: #6c6c6e;
  --input-min-height: 47.2px;
  --input-padding: 10.6px;
  --destructive: #f65151;
  --box-radius: 5px;
  --sidebar-button: #ffffff;
  --sidebar-width: 300px;
}

.dark {
  --background: #282828;
  --background-box: #1c1c1c;
  --background-header: #1b1c1be8;
  --background-info: #1f1f1f;
  --background-input: #171717;
  --background-input-header: #2e2f2e;
  --background-popup-box: var(--background-box);
  --border: #101010b0;
  --border-default: 1px solid var(--border);
  --destructive: #a33030;
  --grid: #242424;
  --text: #bcbcbc;
  --text-important: #e3ebe3;
  --button: #2d4f24;
  --button-disabled: #434343;
  --box-shadow-default: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  --sidebar-button: #365336;
}

a {
  color: var(--link);
  font-weight: 300;
}

a:visited {
  color: var(--link);
}

html {
  height: 100vh;
}

body {
  margin: 0;
  background-color: var(--background);
}

body, #root {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
}

button {
  background-color: var(--button);
  border: none;
  padding: 8px 20px;
  border-radius: 5px;
  font-size: 16px;
  color: var(--button-text);
  transition: 0.05s;
  font-weight: 300;
}

button[disabled] span {
  color: var(--text-disabled);
}

button:hover {
  filter: brightness(0.9);
}

button:hover:active {
  filter: brightness(0.8)
}

button.destructive {
  background-color: var(--destructive);
}

html, body, button, input, textarea {
  font-family: "Lexend Deca";
}

input {
  width: 100%;
  border-radius: 5px;
  border: 1px solid var(--border);
  padding: var(--input-padding);
  box-sizing: border-box;
  background-color: var(--background-input);
  font-weight: 100;
  font-size: 16px;
}

input[type="checkbox"] {
  width: initial;
}

input[type="file"] {
  display: none;
}

p, li {
  font-weight: 100;
  color: var(--text);
  line-height: 1.5rem;
  margin: 0;
}

h1 {
  color: var(--text-important);
  font-weight: 400;
  margin: 0;
  font-size: 22px;
}

.singlePixelBorder {
  border: 1px solid var(--border);
}`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,iBAAiB;EACjB,yCAAyC;EACzC,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,qDAAqD;EACrD,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;EAClC,6CAA6C;EAC7C,mBAAmB;EACnB,yCAAyC;EACzC,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[":focus-visible {\n  outline: none;\n}\n\n:root {\n  --article: #313237;\n  --background: #f6f8fa;\n  --background-box: #fffffff0;\n  --background-header: #f5f4f4b8;\n  --background-label: rgb(236, 236, 236);\n  --background-info: #f1f1f1;\n  --background-input: #eff1f3;\n  --background-popup: #0000009f;\n  --background-popup-box: #eaeaea;\n  --border: #d7d7d7;\n  --border-default: 1px solid var(--border);\n  --button: #5297f1;\n  --button-text: white;\n  --button-border: #2ea15e;\n  --button-hover: #69b65c;\n  --button-disabled: #b8b8b8;\n  --grid: #f8f9fb;\n  --height-header: 35px;\n  --link: #5297f1;\n  --link-selected: #d0dcff;\n  --text: #5f6368;\n  --text-disabled: #999ea4;\n  --text-red: #ff4545;\n  --text-important: #101010;\n  --box-shadow-default: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n  --formatter-selected: #aae9ba;\n  --placeholder: #6c6c6e;\n  --input-min-height: 47.2px;\n  --input-padding: 10.6px;\n  --destructive: #f65151;\n  --box-radius: 5px;\n  --sidebar-button: #ffffff;\n  --sidebar-width: 300px;\n}\n\n.dark {\n  --background: #282828;\n  --background-box: #1c1c1c;\n  --background-header: #1b1c1be8;\n  --background-info: #1f1f1f;\n  --background-input: #171717;\n  --background-input-header: #2e2f2e;\n  --background-popup-box: var(--background-box);\n  --border: #101010b0;\n  --border-default: 1px solid var(--border);\n  --destructive: #a33030;\n  --grid: #242424;\n  --text: #bcbcbc;\n  --text-important: #e3ebe3;\n  --button: #2d4f24;\n  --button-disabled: #434343;\n  --box-shadow-default: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  --sidebar-button: #365336;\n}\n\na {\n  color: var(--link);\n  font-weight: 300;\n}\n\na:visited {\n  color: var(--link);\n}\n\nhtml {\n  height: 100vh;\n}\n\nbody {\n  margin: 0;\n  background-color: var(--background);\n}\n\nbody, #root {\n  width: 100%;\n  height: 100%;\n  overflow-y: hidden;\n}\n\nbutton {\n  background-color: var(--button);\n  border: none;\n  padding: 8px 20px;\n  border-radius: 5px;\n  font-size: 16px;\n  color: var(--button-text);\n  transition: 0.05s;\n  font-weight: 300;\n}\n\nbutton[disabled] span {\n  color: var(--text-disabled);\n}\n\nbutton:hover {\n  filter: brightness(0.9);\n}\n\nbutton:hover:active {\n  filter: brightness(0.8)\n}\n\nbutton.destructive {\n  background-color: var(--destructive);\n}\n\nhtml, body, button, input, textarea {\n  font-family: \"Lexend Deca\";\n}\n\ninput {\n  width: 100%;\n  border-radius: 5px;\n  border: 1px solid var(--border);\n  padding: var(--input-padding);\n  box-sizing: border-box;\n  background-color: var(--background-input);\n  font-weight: 100;\n  font-size: 16px;\n}\n\ninput[type=\"checkbox\"] {\n  width: initial;\n}\n\ninput[type=\"file\"] {\n  display: none;\n}\n\np, li {\n  font-weight: 100;\n  color: var(--text);\n  line-height: 1.5rem;\n  margin: 0;\n}\n\nh1 {\n  color: var(--text-important);\n  font-weight: 400;\n  margin: 0;\n  font-size: 22px;\n}\n\n.singlePixelBorder {\n  border: 1px solid var(--border);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
